import { apiClient } from './apiClient';

import type { LoginPayload, LoginResponse, StaffSessionResponse } from '@/types/auth.types';

export const authService = {
  login: (payload: LoginPayload): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>('/auth/staff/login', payload);
  },

  getStaffSession: (): Promise<StaffSessionResponse> => {
    return apiClient.get<StaffSessionResponse>('/auth/staff/session');
  },
};
